import React from 'react';
import dashboardImg from '../assets/images/dashboard-screenshot.jpg'; // Replace with actual filename
import bookDetailImg from '../assets/images/book-detail-screenshot.jpg'; // Replace with actual filename

const HowToPage = () => (
  <div className="max-w-3xl mx-auto py-10 px-4">
    <h1 className="text-3xl font-bold mb-6 text-primary">How to Use Page4Change</h1>
    <ol className="list-decimal ml-6 space-y-8">
      <li>
        <h2 className="text-xl font-semibold mb-2">Sign Up & Choose Your School</h2>
        <p>
          Visit the sign-up page, enter your details, and select your school from the list. <br />
          <span className="font-semibold">Teachers:</span> Please contact <a href="mailto:zubarem@stpaulsschool.org.uk" className="text-blue-600 underline">zubarem@stpaulsschool.org.uk</a> to receive your special sign-up code.
        </p>
      </li>
      <li>
        <h2 className="text-xl font-semibold mb-2">Access Your Dashboard</h2>
        <p>After signing up, you'll be taken to your personal dashboard:</p>
        <img src={dashboardImg} alt="Dashboard screenshot" className="rounded shadow my-4" />
        <ul className="list-disc ml-6">
          <li>See the number of books you've read</li>
          <li>Track your total reading time</li>
          <li>View your recent books and recommendations</li>
        </ul>
      </li>
      <li>
        <h2 className="text-xl font-semibold mb-2">View and Choose a Book</h2>
        <p>
          Click the <span className="font-semibold">View All Books</span> button to browse the library. Select a book to see its details and interact with it:
        </p>
        <img src={bookDetailImg} alt="Book detail screenshot" className="rounded shadow my-4" />
        <ul className="list-disc ml-6">
          <li>Read and write reviews</li>
          <li>Mark the book as read</li>
          <li>Chat with the book or talk to a character</li>
        </ul>
      </li>
    </ol>
    <div className="mt-10 p-4 bg-blue-50 border-l-4 border-blue-400">
      <h2 className="text-lg font-semibold mb-2">For Teachers</h2>
      <p>
        To sign up as a teacher, please email <a href="mailto:zubarem@stpaulsschool.org.uk" className="text-blue-600 underline">zubarem@stpaulsschool.org.uk</a> to receive your unique access code.
      </p>
    </div>
    <div className="mt-6 p-4 bg-yellow-50 border-l-4 border-yellow-400">
      <p>
        <span className="font-semibold">Feature requests or bugs?</span> Please send them to <a href="mailto:zubarem@stpaulsschool.org.uk" className="text-blue-600 underline">zubarem@stpaulsschool.org.uk</a>.
      </p>
    </div>
  </div>
);

export default HowToPage; 